// extracted by mini-css-extract-plugin
export default {"container":"NJ-z","dimension":"OJ-z","dimensionLabels":"PJ-z"};